import PropTypes from "prop-types";
import { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import s from "./CharacterGroup.module.css";
import ProductCard from "./ProductCard.jsx";

export default function CharacterGroup({
  group,
  onProductClick,
  defaultExpanded,
  gridLimit: limit,
}) {
  const isGeneral = group.character === "General";
  const [expanded, setExpanded] = useState(defaultExpanded || isGeneral);
  const total = group.products.length;
  const needsTruncation = total > limit;
  const visibleProducts =
    isGeneral || expanded || !needsTruncation
      ? group.products
      : group.products.slice(0, limit);
  const remaining = total - limit;

  return (
    <div>
      <div className={s.header}>
        <div className={s.nameBlock}>
          {group.franchise && (
            <span className={s.franchise}>{group.franchise}</span>
          )}
          <span className={s.name}>{group.character}</span>
          {!isGeneral && group.vas.length > 0 && (
            <span className={s.va}>
              {group.vas.map((va, i) => (
                <Fragment key={va.name}>
                  {i > 0 && ", "}
                  <Link to={`/${va.route}`} className={s.vaLink}>
                    {va.name}
                  </Link>
                </Fragment>
              ))}
            </span>
          )}
        </div>
        <span className={s.count}>
          {needsTruncation && !expanded
            ? `Showing ${limit} of ${total}`
            : `${total} product${total !== 1 ? "s" : ""}`}
        </span>
      </div>
      <div className={s.grid}>
        {visibleProducts.map((product) => (
          <ProductCard
            key={product.product_id}
            product={product}
            onClick={onProductClick}
          />
        ))}
      </div>
      {needsTruncation && !isGeneral && (
        <button
          className={s.showAllBtn}
          onClick={() => setExpanded((prev) => !prev)}
          aria-expanded={expanded}
          aria-label={
            expanded
              ? `Show less ${group.character} products`
              : `Show all ${total} ${group.character} products (${remaining} more)`
          }
        >
          {expanded
            ? "Show less"
            : `Show all ${total} products (${remaining} more)`}
        </button>
      )}
    </div>
  );
}

CharacterGroup.propTypes = {
  group: PropTypes.shape({
    character: PropTypes.string.isRequired,
    franchise: PropTypes.string,
    vas: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        route: PropTypes.string,
      }),
    ).isRequired,
    products: PropTypes.array.isRequired,
  }).isRequired,
  onProductClick: PropTypes.func.isRequired,
  defaultExpanded: PropTypes.bool,
  gridLimit: PropTypes.number.isRequired,
};
